import { Box, Checkbox, Collapse, FormField, InputArea, Text, Tooltip } from '@wix/design-system';
import React from 'react';
import { ElementStatus } from '../../../../rule-element/types';
import { RuleTipBox } from '../../../../rule-layout/rule-tip/rule-tip-box';
import { RuleTipItem } from '../../../../rule-layout/rule-tip/rule-tip-item';
export const AltTextImageItemContent = _ref => {
  let {
    value,
    isDecorative,
    isLinked,
    decorativeDisabledTooltip,
    status,
    isDisabled = false,
    showDecorativeOption = true,
    onValueChange,
    onDecorativeChange,
    onBlur,
    label,
    placeholder,
    decorativeLabel,
    helperTip,
    labelSize = 'tiny',
    statusMessage,
    formStatus,
    inputSuffix,
    topContent,
    maxLength = 1000
  } = _ref;
  const isInputDisabled = isDisabled || status === ElementStatus.Loading;
  const isDecorativeDisabledByLink = !!isLinked;
  const isDecorativeCheckboxDisabled = isInputDisabled || isDecorativeDisabledByLink;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: "alt-text-item-content-container",
    direction: "vertical",
    gap: "SP3"
  }, topContent, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: isDecorative && !isDecorativeDisabledByLink ? '0px' : 'SP3'
  }, /*#__PURE__*/React.createElement(Collapse, {
    dataHook: "alt-text-item-content-collapse",
    open: !isDecorative || isDecorativeDisabledByLink
  }, /*#__PURE__*/React.createElement(FormField, {
    dataHook: "alt-text-item-content-form-field",
    label: label,
    labelSize: labelSize,
    status: formStatus,
    statusMessage: statusMessage,
    suffix: inputSuffix
  }, /*#__PURE__*/React.createElement(InputArea, {
    dataHook: "alt-text-item-content-input",
    disabled: isInputDisabled,
    maxLength: maxLength,
    placeholder: placeholder,
    rows: 3,
    size: "small",
    value: value,
    autoFocus: true,
    autoSelect: true,
    onBlur: onBlur,
    onChange: e => onValueChange(e.target.value)
  })), helperTip && /*#__PURE__*/React.createElement(RuleTipBox, {
    marginTop: "SP1",
    padding: "0px"
  }, /*#__PURE__*/React.createElement(RuleTipItem, {
    showIcon: false
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, helperTip)))), showDecorativeOption && /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: decorativeDisabledTooltip ?? '',
    disabled: !isDecorativeDisabledByLink || !decorativeDisabledTooltip
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: isDecorativeDisabledByLink ? false : isDecorative,
    dataHook: "alt-text-item-content-decorative-checkbox",
    disabled: isDecorativeCheckboxDisabled,
    maxLines: 2,
    size: "small",
    vAlign: "top",
    onChange: () => {
      if (isDecorativeDisabledByLink) {
        return;
      }
      onDecorativeChange == null || onDecorativeChange(!isDecorative);
    }
  }, /*#__PURE__*/React.createElement(Box, {
    marginTop: "3px"
  }, /*#__PURE__*/React.createElement(Text, {
    secondary: !isDecorativeCheckboxDisabled,
    size: "tiny",
    skin: isDecorativeCheckboxDisabled ? 'disabled' : undefined
  }, decorativeLabel)))))));
};
//# sourceMappingURL=alt-text-image-item-content.js.map